import Navbar from "../Navbar"
import CaseStudy from "./CaseStudy"

const WorkContent = () => {
  return (
    <div>
        <Navbar work />
        <CaseStudy />
    </div>
  )
}
export default WorkContent